import Cviceni from './cviceni';

const windowLoad = () => {
  console.log('windowLoad:cviceni');

  // instantiate

  // run
  Cviceni
    .loadingScreen();
};

export default windowLoad;
